/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { PolicyEntity, GuardModel, GuardPolicy, GuardRequest } from './types';

export class DefaultGuardModel implements GuardModel {
    protected matchSubject(
        requestSubject: PolicyEntity['subject'],
        policySubject: PolicyEntity['subject']
    ) {
        return requestSubject.role === policySubject.role;
    }

    protected matchResource(
        requestResource: PolicyEntity['resource'],
        policyResource: PolicyEntity['resource']
    ) {
        return requestResource.name === policyResource.name;
    }

    protected matchAction(
        requestAction: PolicyEntity['action'],
        policyAction: PolicyEntity['action']
    ) {
        return requestAction.split(',').every(i => policyAction.split(',').includes(i));
    }

    public effect(request: GuardRequest, policyList: GuardPolicy[]) {
        return policyList.some(policy => this.match(request.toJS(), policy.toJS()));
    }

    public match = (request: PolicyEntity, policy: PolicyEntity) => (
        this.matchSubject(request.subject, policy.subject) &&
        this.matchResource(request.resource, policy.resource) &&
        this.matchAction(request.action, policy.action)
    );
}
